import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: [
    'DV_WEB_PAGINATION_PAGE',
    'DV_WEB_PAGINATION_PREVIOUS',
    'DV_WEB_PAGINATION_NEXT',
  ] as const,
}